import React from 'react'
import NursingDrawer from '../../components/drawers/nursing'
import Locum from '../../components/drawers/locum'
import BilledQueue from '../../components/pages/billedQueue'

const Queue = () => {
    return (
        <BilledQueue
            category="Nursing"
            basePath="/app/nursing/queue"
            DrawerComponent={NursingDrawer}
            extraLinks={[{ to: '/app/nursing/queue/locum', label: 'Locum' }]}
            extraRoutes={[
                {
                    path: '/app/nursing/queue/locum',
                    component: refresh => <Locum department="Nursing" path="/app/nursing/queue" onClose={refresh} />,
                },
            ]}
        />
    )
}

export default Queue
